<template>
    <div>
        <el-dialog :append-to-body="true" :destroy-on-close="true" :visible.sync="orderPreShow"
                   custom-class="OrderPre-Dialog"
                   modal-append-to-body title="">
            <div class="Pre-Content">
                <div class="Pre-Name">
                    <div class="Pre-Name-IK">
                        <span class="Title" style="display: flex;align-items: center;">{{ dataMap.planName }}</span>
                        <img :src="require('@/assets/png/gjpink.png')" alt="" class="Close-Style"
                             @click="orderPreShow = false">
                    </div>
                    <el-divider></el-divider>
                </div>
                <div class="Main-Date">
                    <span class="_span">团号：{{ dataMap.planId }}</span>
                    <div class="Main-Date-Two">
                        <span class="_span">{{ dataMap.startTime }} 至 {{ dataMap.endTime }}</span>
                        <span class="_span"> {{ dataMap.numberOfPeople }}人</span>
                    </div>
                    <el-divider></el-divider>
                </div>
                <div class="Coupon">
                    <span class="Title" style="color: gray">优惠</span>
                    <div class="Coupon-One _margin">
                        <div class="Coupon-One-IK">
                            <img :src="require('@/assets/png/coupon.png')" alt="" class="_img">
                            <span class="_span" style="padding-left: 5px;">优惠券</span>
                        </div>
                        <span style="color: #DD5827;font-size: 12px">暂无可用</span>
                    </div>
                </div>
                <div class="Integral">
                    <div class="Integral-One">
                        <div class="Integral-One-IK">
                            <img :src="require('@/assets/png/Integral1.png')" alt="" class="_img">
                            <span class="_span" style="padding-left: 5px;">积分</span>
                        </div>
                        <span style="color: #DD5827;font-size: 12px">暂无可用积分</span>
                    </div>
                    <el-divider></el-divider>
                </div>
                <div class="Total-Price">
                    <div style="display: flex;align-items: center;flex-direction: column">
                        <p v-if="originalCurrency" class="_p">
                            <span class="_span">原币金额：</span>
                            <span style="color: #DD5827;font-size: 0.16rem">{{ originalCurrency }}</span>
                        </p>
                        <p class="_p">
                            <span class="_span">订单金额：</span>
                            <span style="color: #DD5827;font-size: 0.16rem">¥ {{ dataMap.totalPrice }}</span>
                        </p>
                        <p class="_p">
                            <span class="_span">实付金额：</span>
                            <span style="color: #DD5827;font-size: 0.16rem">¥ {{ dataMap.actualPrice }}</span>
                        </p>
                        <template v-if="dataMap.stateMaps">
                            <p v-for="(item, index) in dataMap.stateMaps.filter(x => x.inventoryExpiredTotalPrice > 0)"
                               :key="index"
                               class="_p">
                                <span class="_span">{{ item.stateName }}库存不足：</span>
                                <span style="color: #DD5827;font-size: 0.16rem">-¥ {{
                                        item.inventoryExpiredTotalPrice
                                    }}</span>
                            </p>
                        </template>
                    </div>
                    <div style="display: flex;flex-direction: column;justify-content: center;align-items: center">
                        <!-- 订单接单类型选择 -->
                        <div style="width: 100%;margin-bottom: 20px;">
                            <div style="margin-bottom: 10px;">
                                <el-radio-group v-model="orderType" size="small">
                                    <el-radio label="self">自己公司接单</el-radio>
                                    <el-radio label="supplier">指定供应商接单</el-radio>
                                </el-radio-group>
                            </div>
                            <div v-if="orderType === 'supplier'" style="margin-top: 10px;">
                                <el-input
                                    v-model.trim="companyId"
                                    clearable
                                    placeholder="请输入指定供应商编号"
                                    size="small"
                                    style="width: 100%;"
                                ></el-input>
                            </div>
                        </div>
                        <el-button :loading="isLoading" round style="background: #DD5827;height: 40px;" type="danger"
                                   @click="placeOrder(false)">{{ isLoading ? '提交中' : '提交订单' }}
                        </el-button>
                        <div style="margin-top: 10px">
                            <span style="cursor: pointer"
                                  @click="$refs.disclaimerClausePopUpBox.open()">查看免责条款</span>
                        </div>
                    </div>
                </div>
                <PriceDetail v-if="true" ref="priceDetail" style="margin-top: 30px"
                             @inventoryPolicyDisplay="inventoryPolicyDisplay">
                </PriceDetail>
            </div>
            <Lbox ref="inventoryPolicyDisplayRef"></Lbox>
            <pay ref="thirdPay" :dataMap="dataMap" :orderChildrenIds="childrenIds" :orderMainId="orderMainId"
                 :payMoney="dataMap.totalPrice" @payUpload="payUpload"></pay>
        </el-dialog>
        <createAVehicleOrder ref="createAVehicleOrder" @confirmed="placeOrder(true)"></createAVehicleOrder>
        <total-order-pop-up-box ref="TotalOrderPopUpBox" @close="orderPreShow=false"></total-order-pop-up-box>
        <disclaimerClausePopUpBox ref="disclaimerClausePopUpBox"></disclaimerClausePopUpBox>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import Lbox from '@/views/plan/leftMoudle/children/Lbox'
import PriceDetail from '@/views/plan/leftMoudle/children/PriceDetail'
import OrderApi from '@/components/Api/order'
import pay from "@/components/ThirdPay/Pay.vue";
import {Loading} from "@/components/Loding/Loading";
import {getBudgetInfo, getPlanInfo} from '../../js/function'
import createAVehicleOrder from './createAVehicleOrder.vue';
import {getGroup} from '../../../../assets/utils/unit';
import store from "@/store/index";
import TotalOrderPopUpBox from "@/views/mechanism/components/myDealChild/child/totalOrderPopUpBox.vue";
import disclaimerClausePopUpBox from "@/views/plan/leftMoudle/dialog/disclaimerClausePopUpBox.vue";
import Api from "@/components/Api";

export default {
    name: '',
    components: {
        TotalOrderPopUpBox,
        Lbox, PriceDetail, pay, createAVehicleOrder, disclaimerClausePopUpBox
    },
    mixins: [Loading],
    // 定义属性
    data() {
        return {
            parameterValue: null,
            isOrderedFlag: false,
            orderPreShow: false,
            isLoading: false,
            budgetIds: [],
            dataMap: {},
            code: '',
            lboxIndex: 0,
            childrenIds: [],
            orderMainId: '',
            orderType: 'self', // 订单接单类型：self-自己公司接单, supplier-指定供应商接单
            companyId: '', // 指定供应商编号
        }
    },

    // 计算属性，会监听依赖属性值随之变化
    computed: {
        originalCurrency() {
            let currencyList = []

            console.log(this.dataMap.stateMaps, '时刻弟弟看看');

            if (this.dataMap.stateMaps) {
                this.dataMap.stateMaps.forEach(items => {
                    currencyList.push(...items.stateMapDetails)
                })
            }
            if (currencyList.length === 1 && currencyList[0].currency === '¥') {
                return false
            }
            let currencyMap = {}
            let results = []//最终结果
            if (currencyList.length > 0) {
                currencyMap = getGroup(currencyList, 'currency')
                for (const key in currencyMap) {
                    let price = currencyMap[key].reduce((prev, cur) => {
                        return prev += (cur.unitPrice * cur.number)
                    }, 0)
                    results.push(key + ' ' + price)
                }
                return results.join('、')
            }
        }
    },
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        payUpload() {
            this.orderPreShow = false
        },
        inventoryPolicyDisplay(data) {
            this.$refs.inventoryPolicyDisplayRef.inventoryPolicyDisplay(data)
        },
        async createOrder(flag) {
            let dataArr = []
            if (this.dataMap.stateMaps.findIndex(n => n.state === 3 || n.state === 5) !== -1 && !flag) {
                await new OrderApi("order").querySurePlan(this.budgetIds).then(res => {
                    if (res.status === 200) {
                        dataArr = res.data
                    } else {
                        this.$message.error(res.statusText)
                    }
                })
            }
            if (dataArr && dataArr.length > 0) {
                this.$refs.createAVehicleOrder.initClick(this.budgetIds)
            } else {
                let obj = {
                    budgetIds: this.budgetIds,
                    code: this.code
                }
                // 如果选择指定供应商接单，添加供应商编号
                if (this.orderType === 'supplier') {
                    if (!this.companyId) {
                        this.$message.warning('请输入指定供应商编号')
                        this.isLoading = false
                        return
                    }
                    obj.companyId = this.companyId
                }
                // 测试用
                this.createLoading({isBody: true, innerText: "订单创建中..."})
                // 创建前,先判断一下该方案是否已经产生过
                new OrderApi("order").createOrder(obj).then(res => {
                    if (res.status === 200) {
                        this.$message.success("订单创建成功...")
                        this.childrenIds = res.data
                        this.orderMainId = res.others
                        this.orderPreShow= false
                        setTimeout(() => {
                            this.$refs.TotalOrderPopUpBox.open({orderMainId: res.others, planId: this.dataMap.planId})
                            this.$refs.thirdPay.init()
                        }, 800)
                        getBudgetInfo(store.state.budgetMainId, null)
                    } else {
                        this.$message.error(res.statusText)
                        if (res.statusText === '存在已定的订单，请刷新页面重试一次...') {
                            this.orderPreShow = false
                            getBudgetInfo(store.state.budgetMainId, null)
                            getPlanInfo(store.state.planId, null)
                        }
                    }
                    this.closeLoading()
                    this.isLoading = false
                })
            }
        },
        async placeOrder(flag) {
            //如果是指定供应商接单
            if (this.orderType === 'supplier') {
                //验证供应商编号是否存在
                if (!this.companyId) {
                    this.$message.warning('请输入指定供应商编号')
                    return
                }
                try {
                    //请求订单修改接口
                     new Api().updateBudgetStockCompany({
                        budgetIds: this.budgetIds,
                        companyId: this.companyId
                    }).then(res => {
                        if (res.status !== 200) {
                            this.$message.error(res.statusText)
                            return
                        }
                        new OrderApi("order").orderPreShow(this.budgetIds, this.parameterValue).then((result) => {
                            if (result.status === 200) {
                                this.code = result.data.code
                            } else {
                                this.$message.error(result.statusText)
                            }
                        }).catch((err) => {
                            this.$message.error(err)
                            this.closeLoading()
                        });
                    })
                } catch (err) {
                    this.$message.error('服务器错误，请联系管理员')
                    return
                }
            }
            this.isLoading = true
            let obj = {
                budgetIds: this.budgetIds,
                code: this.code
            }
            if (this.isOrderedFlag) {
                await this.createOrder(flag)
                return
            }
            // 创建前,先判断一下该方案是否已经产生过
            // new OrderApi("order").isOrdered(obj).then(res => {
            //   if (res.status == 200 && res.data) {
            //     this.$confirm(`该方案内的${res.data}已经下过订单,是否继续？`, '订单提示', {
            //       confirmButtonText: '确定',
            //       cancelButtonText: '取消',
            //       type: 'warning'
            //     }).then(() => {
            //       this.createOrder(flag)
            //     })
            //   } else {
            //     this.createOrder(flag)
            //   }
            //   this.isOrderedFlag = true
            // })
            await this.createOrder(flag)
            this.isOrderedFlag = true
        },
        init(budgetIds, value, stock) {
            this.stockData = stock || {}
            if (!budgetIds || budgetIds.length == 0) {
                this.$message.info("不存在预算单")
            } else {
                this.createLoading({isBody: true})
                this.budgetIds = budgetIds
                this._getData(value)
            }
            this.$nextTick(() => {
                // stateMapDetails

                console.log(this.$e);

            })
        },
        _getData(value) {
            this.parameterValue = value
            this.dataMap = {}
            new OrderApi("order").orderPreShow(this.budgetIds, value).then((result) => {
                if (result.status == 200) {
                    this.orderPreShow = true
                    this.dataMap = result.data.createOrderPreResult
                    this.code = result.data.code
                    this.$nextTick(() => {
                        this.$refs.priceDetail.init(this.dataMap.stateMaps)
                    })
                    this.closeLoading()
                } else {
                    this.$message.error(result.statusText)
                }
            }).catch((err) => {
                this.$message.error(err)
                this.closeLoading()
            });
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {
    }, // 生命周期 - 创建之前
    beforeMount() {
    }, // 生命周期 - 挂载之前
    beforeUpdate() {
    }, // 生命周期 - 更新之前
    updated() {
    }, // 生命周期 - 更新之后
    beforeDestroy() {
    }, // 生命周期 - 销毁之前
    destroyed() {
    }, // 生命周期 - 销毁完成
    activated() {
    }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style>
.OrderPre-Dialog {
    width: 1200px;
    position: absolute;
    left: 50%;
    top: 0%;
    transform: translateX(-50%);
    border-radius: 15px;
    box-shadow: 0 0 3px rgb(0 0 0 / 50%);
    background-color: white;
}

.OrderPre-Dialog .el-dialog__header {
    display: none;
}

.OrderPre-Dialog .el-dialog__body {
    display: flex;
    padding: 0;
}
</style>
<style lang="scss" scoped>
/deep/ .el-divider--horizontal {
    margin: 10px 0;
}

._p {
    width: 300px;
}

._span {
    display: inline-block;
    font-size: 0.12rem;
    color: gray;
}

._img {
    width: 20px;
    height: 20px;
}

._margin {
    margin-top: 10px;
}

.Pre-Content {
    border-right: 1px dashed #DCDFE6;
    width: 870px;
    background: white;
    padding: 20px;
    margin: 10px;
    margin-right: 0px;

    .Pre-Name-IK {
        display: flex;
        justify-content: space-between;
    }

    .Main-Date {
        .Main-Date-Two {
            margin-top: 10px;
            display: flex;
            justify-content: space-between;

            > span:nth-child(1) {
                color: #DD5827;
            }
        }
    }

    .Integral {
        margin-top: 10px;

        .Integral-One {
            display: flex;
            justify-content: space-between;

            .Integral-One-IK {
                display: flex;

                > span {
                    display: flex;
                    align-items: center;
                }
            }
        }
    }

    .Coupon {
        .Coupon-One {
            display: flex;
            justify-content: space-between;

            .Coupon-One-IK {
                display: flex;

                > span {
                    display: flex;
                    align-items: center;
                }
            }
        }
    }

    .Total-Price {
        display: flex;
        justify-content: space-between;
    }

    .Title {
        font-size: 0.17rem;
        font-weight: 700;
        padding-right: 10px;
    }

    .Close-Style:hover {
        cursor: pointer;
    }

    .Close-Style {
        width: 35px;
        height: 35px;
    }
}
</style>
